import React from 'react';
import { useStore } from 'effector-react';
import { PanelType } from '@types';
import { $panel } from '@stores/panelStores';
import EnterCoverLayer from './EnterCoverLayer';
import { SandTableLayer } from './SandTableLayer';
import { ConfigLoadingLayer } from './ConfigLoadingLayer';

function SceneLayers() {
  const { type } = useStore($panel);
  switch (type) {
    case PanelType.enterCover:
      return <EnterCoverLayer />;
    case PanelType.sandTable:
      return <SandTableLayer />;
    case PanelType.loading:
      return <ConfigLoadingLayer />;
    default:
      return null;
  }
}

export default SceneLayers;
